<template lang="pug">
  div
    button.btn.btn-success.sel-persons-btn(v-if="!view_mode" type="button", @click="openModalSelPerson", data-testid="btn-sel-person") {{buttonName}}
    .selected-box
      div.label.bcard-search-user-selected(v-for="(item, index) in modalSelPerson.selectedItems", :key="item.id" :title="item.full_name")
        input(type="hidden", :name="inputName", v-model="item.id")
        span {{item.full_name}}
        i.fa.fa-times(v-if="!view_mode" @click="removeSelectedPerson(index)")

    //- 既存データを消すためのhidden
    input(
      v-if="maxSelect === '1' && modalSelPerson.selectedItems.length === 0",
      type="hidden",
      :name="inputName",
      value=""
    )

    //- 余計なフォームデータが埋め込まれないように、使わないときは隠す
    //- と思ったけど、v-modelをwatchできなくなるのでここでやるのはやめた
    modal-sel-person(v-model="modalSelPerson", :maxSelect="maxSelect", @input="onChangeSelectedPersons")
</template>

<script>
import ModalSelPerson from '@/components/organisms/ModalSelPerson'

export default {
  name: 'SelPersons',
  components: { ModalSelPerson },
  props: {
    value: {
      type: [Array, Object],
      default () { // selectedItems
        return []
      }
    },
    maxSelect: {type: Number, required: false, default: 100000},
    buttonName: {type: String, required: false, default: '名刺人物選択'},
    inputName: {type: String, required: false, default: 'persons[]'},
    view_mode: {type: Boolean, required: false, default: false}, // 表示モード
    doReset: {type: Boolean, required: false, default: false} // リセットフラグ
  },
  data () {
    return {
      initialized: false,
      // 名刺人物選択モーダル
      modalSelPerson: {
        isOpen: false,
        selectedIds: [],
        selectedItems: []
      }
    }
  },
  watch: {
    value (newValue, oldValue) {
      // 初回のみ
      if (!oldValue || newValue.length !== oldValue.length) {
        this.initData()
      }
    },
    doReset (newValue) {
      if (newValue) {
        this.initialized = false
        this.initData()
      }
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      // 親画面のロードに合わせるためのwatchなので、
      // 最初の1回だけ実行する
      // （そうでないとwatch.valueが無限ループになる）
      if (this.initialized) {
        return
      }

      let items = []
      // 1件の場合arrayにする
      if (Array.isArray(this.value)) {
        items = this.value
      }
      else {
        if (this.value) {
          items = [this.value]
        }
      }

      // 初期化してから入れ直す
      this.modalSelPerson.selectedItems = []
      this.modalSelPerson.selectedIds = []

      for (let item of items) {
        this.modalSelPerson.selectedItems.push(item)
        this.modalSelPerson.selectedIds.push(item.id)
      }

      this.initialized = true
    },
    /**
     * 名刺人物選択ダイアログを開く
     * @param modalSelPerson
     */
    openModalSelPerson () {
      this.modalSelPerson.isOpen = true
    },
    /**
     * 選択名刺人物を解除する
     * @param modalSelPerson
     */
    removeSelectedPerson (index) {
      this.modalSelPerson.selectedIds.splice(index, 1)
      this.modalSelPerson.selectedItems.splice(index, 1)
      this.onChangeSelectedPersons(this.modalSelPerson)
    },
    onChangeSelectedPersons (modalSelPerson) {
      // 新規画面の場合、こちらでフラグを立てておく
      // （そうでないとwatch.valueが無限ループになる）
      this.initialized = true

      this.$emit(
        'input',
        // 単数選択の場合は配列じゃなくて1件そのものを返す
        this.maxSelect === 1 ? modalSelPerson.selectedItems[0] : modalSelPerson.selectedItems
      )
    }
  }
}
</script>

<style scoped>
.loading {
  text-align: center;
}

.sel-persons-btn + .selected-box {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/SelPersons.vue